import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    SeeProducts, SeeProductsByWinery, createProduct, deleteProduct, updateProduct, SeeProductsHistory
} from '../../actions/productActions'
import {
    seeWineries
} from '../../actions/wineryActions'
import { Field, Form, Formik, useFormik } from 'formik';
import Calendar from 'react-calendar';
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import calendarioImg from '../../../img/calendario.png'
import { SeeCategories } from '../../actions/pCategoriesActions';
import { SeeSubCategories } from '../../actions/subCategoriesActions';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';
import useModal from '../../../utils/hooks/useModal';

const ProductsItemMenuHistory = ({ }) => {
    const dispatch = useDispatch()
    const { productsList, isLoadingProductsList } = useSelector(state => state.productsAdmin)
    useTokenCallback(() => {
        dispatch(SeeProductsHistory())
    }, [])
    return (
        <div className="container-mark-type-admin">
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>
                    Productos existente
                </div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingProductsList ? <div>Cargando...</div> :
                        productsList.map((product, index) => (
                            <div key={index} className="card-admin">
                                <img className="img-card-admin" src={product.image?.url?.origin}></img>
                                <div className="tittle-card-admin">{product.name}</div>
                                <div className="tittle-card-admin">{product.reasonForDeletion}</div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const Modal = ({ closeModal, displayModal, product,formRef }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(e)
    }
    const ref = useRef(null)
    const dispatch = useDispatch();
    return <div
        className={"modal"}
        style={divStyle}
        ref={ref}
        onClick={close}>
        <div
            className="modal-content modal-content-new-post"
            onClick={e => e.stopPropagation()} >
            <Formik
                onSubmit={(values) => {
                    ref.current.click()
                    dispatch(deleteProduct(product._id,values.reasonForDeletion)).then(()=>{
                        formRef.current.resetForm()
                    })
                }}
                initialValues={{ reasonForDeletion: "" }}>
                {(props) => (
                    <Form>
                        <div className="text-input-admin">
                            Introduzca la razon que el producto: {product.name} sea eliminado
                        </div>
                        <Field className='inputs-admin' name="reasonForDeletion" />
                        <div className="content-buttom-create">
                            <button type='button' onClick={(e)=>{closeModal(e)}} className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('cancel', 'es')}</button>
                            <button type='submit' className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('create', 'es')}</button>
                        </div>
                    </Form>)}

            </Formik>
        </div>
    </div>
}
export default ProductsItemMenuHistory